export const actionTypes = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',

    register: '[Auth] Register',

    updateZone: '[Zones] Update',
    clearSelectedZone: '[Zones] Clear',

    updateTheme: '[Themes] Update',
    clearSelectedTheme: '[Themes] Clear',

    showModalPremium: '[UI] Show Modal Premium',
    showPublishZoneBar: '[UI] Show Publish Zone Bar',

    showPreviewButton: '[UI] Show preview button',

    updateSubscription: '[Subscription] Update',
    clearSubscription: '[Subscription] Clear',

    updatePlan: '[Plan] Update',
    clearPlan: '[Plan] Clear',

    updateUi: '[UI] Update UI'
}